import React, { useState } from "react";
import {
  View,
  Image,
  Text,
  TouchableOpacity,
  StyleSheet,
  Dimensions,
  Modal,
} from "react-native";
import { AppImages } from "../../utility/AppImages";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";

const { width } = Dimensions.get("window");

const sliderImages = [
  {
    image: AppImages.icRTMP1,
    step: "Open OBS and navigate to top lef tab. Click on ‘Docks”",
  },
  {
    image: AppImages.icRTMP2,
    step: "In the dropdown click on the ’’multiple output’’",
  },
  {
    image: AppImages.icRTMP3,
    step: "From the left window click on the add new target",
  },
  {
    image: AppImages.icRTMP4,
    step: "Find teh URK and Stream key in the Multiteam settings",
  },
  {
    image: AppImages.icRTMP5,
    step: "Select the target platform and copy and past the url and stream key",
  },
];

const RtmpStepsSlider = ({ modalVisible, setModalVisible, selectedStep }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const styles = useStyles();
  const goNext = () => {
    if (currentIndex < sliderImages.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const goPrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };
  const deviceSize = useDeviceSize();

  return (
    <Modal
      visible={modalVisible}
      transparent={true}
      animationType="fade"
      onRequestClose={() => setModalVisible(false)}
    >
      <View
        style={{
          flex: 1,
          backgroundColor: AppColors.blackTrans_000000a8,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <TouchableOpacity
          style={{ position: "absolute", width: "100%", height: "100%" }}
          onPress={() => setModalVisible(false)}
        />
        <View
          style={[
            {
              backgroundColor: AppColors.gray_434343,
              padding:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? 12
                  : 24,
              elevation: 5,
              width:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "90%"
                  : "auto",
            },
          ]}
        >
          <Image
            source={sliderImages[currentIndex].image}
            style={styles.image}
            resizeMode="contain"
          />

          <View style={styles.container}>
            {/* Navigation Buttons */}
            <View style={styles.buttonContainer}>
              <TouchableOpacity
                onPress={goPrevious}
                disabled={currentIndex === 0}
                style={[
                  styles.button,
                  currentIndex === 0 && styles.disabledButton,
                ]}
              >
                <Image
                  source={AppImages.icArrowLeft}
                  style={{ width: 20, height: 20 }}
                />
              </TouchableOpacity>

              <View
                style={{
                  width:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? 250
                      : 366,
                  flexDirection: "row",
                  gap: 7,
                }}
              >
                <Text
                  style={{
                    ...AppFontStyle.REGULAR_ANYBODY_14,
                    color: AppColors.gray_C4C4C4,
                    minWidth: 50,
                  }}
                >
                  Step {currentIndex + 1}:
                </Text>
                <Text style={AppFontStyle.REGULAR_ANYBODY_14}>
                  {sliderImages[currentIndex].step}
                </Text>
              </View>

              <TouchableOpacity
                onPress={goNext}
                disabled={currentIndex === sliderImages.length - 1}
                style={[
                  styles.button,
                  currentIndex === sliderImages.length - 1 &&
                    styles.disabledButton,
                ]}
              >
                <Image
                  source={AppImages.icArrowRight}
                  style={{ width: 20, height: 20 }}
                />
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default RtmpStepsSlider;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
    },
    image: {
      width: 1128,
      height: 667,
      resizeMode: "contain",
    },
    buttonContainer: {
      flexDirection: "row",
      gap: 75,
      marginTop: 20,
      alignItems: "center",
      width: 596,
    },

    button: {
      padding: 12,
      borderRadius: 178,
      backgroundColor: "#FFFFFF33",
    },

    disabledButton: {
      display: "none",
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {
      image: { width: "100%", height: 238 },
      buttonContainer: {
        gap: 10,
        width: "100%",
        justifyContent: "center",
      },
      button: {
        padding: 5,
      },
    },
    [DEVICE_SIZES.XS]: {
      image: { width: "100%", height: 238 },
      buttonContainer: {
        gap: 10,
        width: "100%",
        justifyContent: "center",
      },
      button: {
        padding: 5,
      },
    },
  }
);
